import {AfterContentInit, AfterViewInit, Component, OnInit} from '@angular/core';
import {VnaServicesService} from '../../../service/vna-services.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AlertaService} from '../../../../shared/services/alerta.service';

@Component({
  selector: 'app-edit-service',
  templateUrl: './edit-service.component.html',
  styleUrls: ['./edit-service.component.scss']
})
export class EditServiceComponent implements OnInit {

    loading: boolean = false;
    service: Object = {};

    form: FormGroup;
    config: Object = {};
    auth: Object = {};

    submitted: boolean = false;

    showingConfig: boolean = true;
    showingAuth: boolean = false;

    jsonErrors: Object = {};

    pkService: number;

    constructor(private servicesHandler: VnaServicesService, private activatedRoute: ActivatedRoute, private fb: FormBuilder, private alertService: AlertaService, private router: Router) {
        this.form = this.fb.group({
            name: new FormControl('', Validators.required),
            type: new FormControl('', Validators.required),
            alias: new FormControl('', Validators.required),
            active: new FormControl('0'),
            external: new FormControl('0'),
            description: new FormControl()
        });

        this.jsonErrors['config'] = false;
        this.jsonErrors['auth'] = false;
    }

    /**
     *
     */
    ngOnInit() {

        this.activatedRoute.params.subscribe(
            (params: Object) => {
                if(params.hasOwnProperty('pk')){
                    this.loading = true;
                    this.pkService = params['pk'];
                    this.servicesHandler.getVnaService(this.pkService).subscribe(
                        (srv: Object) => {
                            this.service = srv;
                            this.config = this.service['config'];
                            this.auth = this.service['auth'];

                            this.fillForm();
                            this.loading = false;
                        }
                    )
                }

            }
        )
    }

    createService(): void {
        if(!this.form.valid || this.jsonErrors['config'] || this.jsonErrors['auth']){
            this.submitted = true;
            return;
        }

        this.loading = true;
        let serviceData = Object.assign({}, this.form.value);
        serviceData['config'] = JSON.parse(this.codeConfig);
        serviceData['auth'] = JSON.parse(this.codeAuth);

        this.servicesHandler.postVnaService(serviceData).subscribe(
            (r) => {
                this.alertService.addAlert('success', 'Service ' + this.form.value['name'] + ' has been created successfully');
                this.loading = false;
                this.router.navigate(['/service/edit', r['pk']]);
            }
        )
    }

    /**
     *
     */
    updateService(): void {

        if(!this.form.valid || this.jsonErrors['config'] || this.jsonErrors['auth']){
            this.submitted = true;
            return;
        }

        this.loading = true;
        let serviceData = Object.assign({}, this.form.value);
        serviceData['config'] = JSON.parse(this.codeConfig);
        serviceData['auth'] = JSON.parse(this.codeAuth);

        this.servicesHandler.putVnaService(this.pkService, serviceData).subscribe(
            (r) => {
                this.alertService.addAlert('success', 'Service ' + this.form.value['name'] + ' has been updated successfully');
                this.loading = false;
            }
        )

    }

    /**
     *
     */
    showConfig(): void {
        this.showingConfig = !this.showingConfig
    }

    /**
     *
     */
    showAuth(): void {
        this.showingAuth = !this.showingAuth;
    }

    /**
     *
     * @returns {string}
     */
    get codeConfig () {
        return JSON.stringify(this.config, null, 2);
    }

    /**
     *
     * @param v
     */
    set codeConfig (v) {
        try{
            this.config = JSON.parse(v);
            this.jsonErrors['config'] = false;
        }
        catch(e) {
            this.jsonErrors['config'] = true;
        };
    }

    /**
     *
     * @returns {string}
     */
    get codeAuth () {
        return JSON.stringify(this.auth, null, 2);
    }

    /**
     *
     * @param v
     */
    set codeAuth (v) {
        try{
            this.auth = JSON.parse(v);
            this.jsonErrors['auth'] = false
        }
        catch(e) {
            this.jsonErrors['auth'] = true;
        };
    }

    protected fillForm() {
        this.form.controls['name'].setValue(this.service['name']);
        this.form.controls['type'].setValue(this.service['type']);
        this.form.controls['alias'].setValue(this.service['alias']);
        this.form.controls['active'].setValue(this.service['active']);
        this.form.controls['external'].setValue(this.service['external']);
        this.form.controls['description'].setValue(this.service['description']);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/services/edit-service/edit-service.component.ts